export * from './stopFilters';
export * from './selectedParcels';

export const CLEAR_ALL = 'UI/@@ROUTE_DETAILS/CLEAR_ALL';

export const clearAll = () => ({ type: CLEAR_ALL });
